// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j0h9hd_glvI9xdOnaauY {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
}

.EM2ge58avb7aQ3AkHwXF {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--midnight-purple);
  opacity: 0;
  transition: opacity 300ms ease-in-out;
}

.hYdDbe4mGmX6DZlM2MZo .EM2ge58avb7aQ3AkHwXF {
    opacity: 0.72;
  }

.zfhCat_hfPJgczWK2PPn .EM2ge58avb7aQ3AkHwXF {
    opacity: 0;
  }

.NwCQzkQDPugpK9RvPNsE {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  height: 100%;
  width: 100%;
  overflow: hidden;
  opacity: 0
}

.NwCQzkQDPugpK9RvPNsE.nr8r1_LafCypHivC8b12 {
    transition: all 0.5s ease-in-out;
    transform: translateY(-50%) translateX(0%);
    opacity: 0.4;
  }

.NwCQzkQDPugpK9RvPNsE.YYVhPTOQqa7huXanBnhP {
    transform: translateY(-50%) translateX(-50%);
    opacity: 1;
  }

.NwCQzkQDPugpK9RvPNsE.FKFPgrc00GnywQ5uyKNM {
    transform: translateY(-50%) translateX(0%);
    opacity: 0;
  }

.NwCQzkQDPugpK9RvPNsE.i8w0r0Hnk3DTdpUyxrON {
    transition: all 0.5s ease-in-out;
    transform: translateY(100%);
  }

.NwCQzkQDPugpK9RvPNsE.hGpGfr_b3zaFbye2XPox {
    transform: translateY(0);
    opacity: 1;
  }

.NwCQzkQDPugpK9RvPNsE.aDZnk4VNA2jHxHd_VumJ {
    transform: translateY(100%);
    opacity: 0;
  }

.NwCQzkQDPugpK9RvPNsE.oiGkiDWjVIkLV1MXTlEe {
    transition: all 0.5s ease-in-out;
    transform: translateX(100%);
  }

.NwCQzkQDPugpK9RvPNsE.dg9ZYRdIozMXkLwLS2rR {
    transform: translateX(0);
    opacity: 1;
  }

.NwCQzkQDPugpK9RvPNsE._F1y6R820wRSz56cNrv_ {
    transform: translateX(100%);
    opacity: 0.4;
  }

.NwCQzkQDPugpK9RvPNsE.iKR_DFwYy3dTdwh71b9L {
    transition: all 0.5s ease-in-out;
    opacity: 0.4;
  }

.NwCQzkQDPugpK9RvPNsE.jBwjU4v37ozQVwNFf9_U {
    opacity: 1;
  }

.NwCQzkQDPugpK9RvPNsE.LT01z2K5i3oFBbO3MkuC {
    opacity: 0;
  }

.NwCQzkQDPugpK9RvPNsE.saM9Z9wiEYSjtCzuPx_j {
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
  }

.NwCQzkQDPugpK9RvPNsE.d9LUDC3onUEpbcQP4WKX {
    transform: translateY(0);
  }

.NwCQzkQDPugpK9RvPNsE.FmlmcctBWhTvPiX9oDwa {
    transform: translateY(100%);
  }

._akYdg1M17z6uL5BvlWt {
  display: block;
}

.xk3VMIVCJHVCUQObYk4r {
  overflow-y: auto;
  height: 100%;
}

.y_3nPWGDROnPILLFYPs_ {
  position: absolute;
  top: 1rem;
  left: 1.125rem;
  border-radius: var(--logo-border-radius);
}

.Y67UFAmwrP8xiPA27pNA {
  position: absolute;
  top: 1.25rem;
  left: 1.125rem;
  cursor: pointer;
  width: 1.25rem;
}

.qxuNkLvbbU1T2D8QgKl9 {
  position: absolute;
  top: 1.25rem;
  right: 1.125rem;
  cursor: pointer;
  width: 1.5rem;
}

.zVhGfbomQP9PxjpUmCcj {
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: 7;
  bottom: 1.25rem;
}

.UI1vM3qUiAsX4MUeAxrU {
  width: 100%;
  height: 0.625rem;
  position: absolute;
  top: 1rem;
  display: flex;
  justify-content: center;
}

.Zqrrg0HteV8y6odcNhqu {
  width: 5rem;
  background-color: rgba(77, 51, 134, 0.2);
  border-radius: 0.3125rem;
  cursor: grab;
  height: 0.25rem;
}

@media only screen and
  (max-width: 639px) {
  .NwCQzkQDPugpK9RvPNsE {
    height: calc(100% - 1.5625rem);
    width: 100%;
    margin-top: 1.5625rem;
    border-radius: var(--panel-border-radius) var(--panel-border-radius) 0 0;
  }
    .KT1in5IbXljr78JBpb1j::before {
      position: absolute;
      content: '';
      height: 0.75rem;
      top: 0.8125rem;
      left: 4%;
      right: 4%;
      border-top-left-radius: 0.75rem;
      border-top-right-radius: 0.75rem;
      background-color: var(--grey-200);
    }

  .zVhGfbomQP9PxjpUmCcj {
    bottom: 1.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,UAAU;EACV,qCAAqC;AACvC;;AAGE;IACE,aAAa;EACf;;AAIA;IACE,UAAU;EACZ;;AAGF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB;AAyEF;;AAvEE;IACE,gCAAgC;IAChC,0CAA0C;IAC1C,YAAY;EACd;;AAEA;IACE,4CAA4C;IAC5C,UAAU;EACZ;;AAEA;IACE,0CAA0C;IAC1C,UAAU;EACZ;;AAEA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;;AAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;;AAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;AAEA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;;AAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;;AAEA;IACE,2BAA2B;IAC3B,YAAY;EACd;;AAEA;IACE,gCAAgC;IAChC,YAAY;EACd;;AAEA;IACE,UAAU;EACZ;;AAEA;IACE,UAAU;EACZ;;AAEA;IACE,2BAA2B;IAC3B,sCAAsC;EACxC;;AAEA;IACE,wBAAwB;EAC1B;;AAEA;IACE,2BAA2B;EAC7B;;AAGF;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAS;EACT,cAAU;EACV,eAAe;EACf,cAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAS;EACT,eAAW;EACX,eAAe;EACf,aAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,wBAAkB;EAClB,YAAY;EACZ,eAAW;AACb;;AAEA;;EACE;IACE,8BAAyB;IACzB,WAAW;IACX,qBAAgB;IAChB,wEAAwE;EAC1E;IAGE;MACE,kBAAkB;MAClB,WAAW;MACX,eAAY;MACZ,cAAS;MACT,QAAQ;MACR,SAAS;MACT,+BAA4B;MAC5B,gCAA6B;MAC7B,iCAAiC;IACnC;;EAGF;IACE,gBAAY;EACd;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100;\n  display: flex;\n}\n\n.backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--midnight-purple);\n  opacity: 0;\n  transition: opacity 300ms ease-in-out;\n}\n\n.overlayAfterOpen {\n  & .backdrop {\n    opacity: 0.72;\n  }\n}\n\n.overlayBeforeClose {\n  & .backdrop {\n    opacity: 0;\n  }\n}\n\n.modalContentWrapper {\n  position: relative;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: white;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  opacity: 0;\n\n  &.animationFromLeftToRightBase {\n    transition: all 0.5s ease-in-out;\n    transform: translateY(-50%) translateX(0%);\n    opacity: 0.4;\n  }\n\n  &.animationFromLeftToRightShow {\n    transform: translateY(-50%) translateX(-50%);\n    opacity: 1;\n  }\n\n  &.animationFromLeftToRightHide {\n    transform: translateY(-50%) translateX(0%);\n    opacity: 0;\n  }\n\n  &.animationFromDownToTopBase {\n    transition: all 0.5s ease-in-out;\n    transform: translateY(100%);\n  }\n\n  &.animationFromDownToTopShow {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  &.animationFromDownToTopHide {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  &.animationFromOuterToRightBase {\n    transition: all 0.5s ease-in-out;\n    transform: translateX(100%);\n  }\n\n  &.animationFromOuterToRightShow {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n  &.animationFromOuterToRightHide {\n    transform: translateX(100%);\n    opacity: 0.4;\n  }\n\n  &.animationOpacityBase {\n    transition: all 0.5s ease-in-out;\n    opacity: 0.4;\n  }\n\n  &.animationOpacityShow {\n    opacity: 1;\n  }\n\n  &.animationOpacityHide {\n    opacity: 0;\n  }\n\n  &.animationNoOpacityBase {\n    transform: translateY(100%);\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &.animationNoOpacityShow {\n    transform: translateY(0);\n  }\n\n  &.animationNoOpacityHide {\n    transform: translateY(100%);\n  }\n}\n\n.header {\n  display: block;\n}\n\n.content {\n  overflow-y: auto;\n  height: 100%;\n}\n\n.logo {\n  position: absolute;\n  top: 16px;\n  left: 18px;\n  border-radius: var(--logo-border-radius);\n}\n\n.backBtn {\n  position: absolute;\n  top: 20px;\n  left: 18px;\n  cursor: pointer;\n  width: 20px;\n}\n\n.closeBtn {\n  position: absolute;\n  top: 20px;\n  right: 18px;\n  cursor: pointer;\n  width: 24px;\n}\n\n.fixedFooter {\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  z-index: 7;\n  bottom: 20px;\n}\n\n.modalDragHandle {\n  width: 100%;\n  height: 10px;\n  position: absolute;\n  top: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.modalDragHandleLine {\n  width: 80px;\n  background-color: rgba(77, 51, 134, 0.2);\n  border-radius: 5px;\n  cursor: grab;\n  height: 4px;\n}\n\n@media (--mobile) {\n  .modalContentWrapper {\n    height: calc(100% - 25px);\n    width: 100%;\n    margin-top: 25px;\n    border-radius: var(--panel-border-radius) var(--panel-border-radius) 0 0;\n  }\n\n  .topShadow {\n    &::before {\n      position: absolute;\n      content: '';\n      height: 12px;\n      top: 13px;\n      left: 4%;\n      right: 4%;\n      border-top-left-radius: 12px;\n      border-top-right-radius: 12px;\n      background-color: var(--grey-200);\n    }\n  }\n\n  .fixedFooter {\n    bottom: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `j0h9hd_glvI9xdOnaauY`,
	"backdrop": `EM2ge58avb7aQ3AkHwXF`,
	"overlayAfterOpen": `hYdDbe4mGmX6DZlM2MZo`,
	"overlayBeforeClose": `zfhCat_hfPJgczWK2PPn`,
	"modalContentWrapper": `NwCQzkQDPugpK9RvPNsE`,
	"animationFromLeftToRightBase": `nr8r1_LafCypHivC8b12`,
	"animationFromLeftToRightShow": `YYVhPTOQqa7huXanBnhP`,
	"animationFromLeftToRightHide": `FKFPgrc00GnywQ5uyKNM`,
	"animationFromDownToTopBase": `i8w0r0Hnk3DTdpUyxrON`,
	"animationFromDownToTopShow": `hGpGfr_b3zaFbye2XPox`,
	"animationFromDownToTopHide": `aDZnk4VNA2jHxHd_VumJ`,
	"animationFromOuterToRightBase": `oiGkiDWjVIkLV1MXTlEe`,
	"animationFromOuterToRightShow": `dg9ZYRdIozMXkLwLS2rR`,
	"animationFromOuterToRightHide": `_F1y6R820wRSz56cNrv_`,
	"animationOpacityBase": `iKR_DFwYy3dTdwh71b9L`,
	"animationOpacityShow": `jBwjU4v37ozQVwNFf9_U`,
	"animationOpacityHide": `LT01z2K5i3oFBbO3MkuC`,
	"animationNoOpacityBase": `saM9Z9wiEYSjtCzuPx_j`,
	"animationNoOpacityShow": `d9LUDC3onUEpbcQP4WKX`,
	"animationNoOpacityHide": `FmlmcctBWhTvPiX9oDwa`,
	"header": `_akYdg1M17z6uL5BvlWt`,
	"content": `xk3VMIVCJHVCUQObYk4r`,
	"logo": `y_3nPWGDROnPILLFYPs_`,
	"backBtn": `Y67UFAmwrP8xiPA27pNA`,
	"closeBtn": `qxuNkLvbbU1T2D8QgKl9`,
	"fixedFooter": `zVhGfbomQP9PxjpUmCcj`,
	"modalDragHandle": `UI1vM3qUiAsX4MUeAxrU`,
	"modalDragHandleLine": `Zqrrg0HteV8y6odcNhqu`,
	"topShadow": `KT1in5IbXljr78JBpb1j`
};
export default ___CSS_LOADER_EXPORT___;
